<template>
  <section >
    
      <div id="alert-box">
        <div class="alert-box-head">
          <div class="container">
            <h2>Welcome to the Our Air Video Challenge!</h2>
           <div class="alert-button">
          <a class="btn btn-draft" role="button" href="http://drishtiair.com/video-challenge" target="_blank">Know More</a>
        </div>
          </div>
        </div>
        <!-- <div class="container">
          <div class="alert-box-content">
            <p>The Drishti Our Air Video Challenge is a student video competition organized by Drishti Kathmandu to raise awareness about, and a call to action to improve the air quality in Kathmandu. Students are invited to submit a video that informs viewers about the facts about air pollution and the impact it has on individuals and communities. The videos should also highlight innovative solutions to the air quality problem and be a call to action to individuals and institutions to mitigate the problem.</p>
          </div>
          
        </div> -->
       
      </div>

  </section>
</template>

<script>
export default {
  name :'videochallenge',
  data() {
    return {
      message : 'Video challenge'
    }
  }
}
</script>
<!-- css link -->
<style src="../assets/video-challenge.css"></style>



// WEBPACK FOOTER //
// VideoChallenge.vue?645b0174